import { render, staticRenderFns } from "./AdditionalLayout.vue?vue&type=template&id=02da1449&"
import script from "./AdditionalLayout.vue?vue&type=script&lang=js&"
export * from "./AdditionalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports